<div class="flex flex-col gap-16 p-5">
  <!-- Sección de la cabecera. -->
  <section class="w-full flex flex-col items-center gap-5">
    <div class="text-2xl font-medium text-center">Editar un empleado</div>
  </section>

  <!-- Sección del cuerpo. -->
  <section>
    <!-- Formulario. -->
    <form class="flex flex-col" [formGroup]="form" (ngSubmit)="update()">
      <mat-form-field>
        <mat-label>ID</mat-label>
        <input
          type="number"
          name="employeeId"
          formControlName="employeeId"
          matInput
          readonly
        />
      </mat-form-field>

      @if (loadingRoles) {
      <div class="h-8 bg-gray-200 cursor-wait animate-pulse"></div>
      } @else { @if (roles.length) {
      <mat-form-field class="w-full">
        <mat-label>Elige los permisos</mat-label>
        <mat-select formControlName="roleId">
          @for (role of roles; track role.id) {
          <mat-option [value]="role.id">{{ role.displayName }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      } @else {
      <div class="text-gray-500 text-center">No hay permisos disponibles</div>
      } }

      <mat-form-field>
        <mat-label>Nombre</mat-label>
        <input
          type="text"
          name="displayName"
          formControlName="displayName"
          matInput
        />
      </mat-form-field>

      <mat-form-field>
        <mat-label>Nombre de usuario</mat-label>
        <input
          type="text"
          name="username"
          formControlName="username"
          matInput
        />
      </mat-form-field>

      <mat-form-field>
        <mat-label>Correo electrónico</mat-label>
        <input type="text" name="email" formControlName="email" matInput />
      </mat-form-field>

      <mat-slide-toggle formControlName="status" class="mt-5">
        <span class="text-base pl-2">{{
          formStatus?.value ? "Activo" : "Deshabilitado"
        }}</span>
      </mat-slide-toggle>

      <!-- Errores. -->
      @if (errors) {
      <div class="flex flex-col gap-2 text-center mt-10">
        @for (error of errors; track error) {
        <span class="text-sm text-red-500">{{ error }}</span>
        }
      </div>
      }

      <!-- Botón de acción. -->
      <button
        type="submit"
        mat-flat-button
        class="mt-10"
        [disabled]="form.invalid || loadingUpdate"
      >
        @if (loadingUpdate) {
        <mat-spinner diameter="18"></mat-spinner>
        } @else {
        <span class="text-base">Editar</span>
        }
      </button>
    </form>
  </section>
</div>
